var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_shell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.4,27.6H2.5V4.5H29.4Zm-25.9-1H28.4V5.5H3.5Z",
    style: {
      fill: "#d9b400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.077 19.316 5.522 18.484 10.366 15.255 5.479 11.184 6.12 10.416 12.035 15.344 6.077 19.316",
    style: {
      fill: "#d9b400"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 18.2,
    width: 7.8,
    height: 1,
    style: {
      fill: "#d9b400"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5.5,
    width: 26.9,
    height: 1.9,
    style: {
      fill: "#d9b400"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShell);
export default __webpack_public_path__ + "static/media/shell.243bdda2438e3d441f8bc914fc0a0053.svg";
export { ForwardRef as ReactComponent };